export default {
  es: {
    enlaces: {
      contacto: "/contacto",
      tutores: "/servicios/tutores",
      titulados: "/servicios/titulados",
      empresas: "/servicios/empresas",
      colaboradores: "/colaboradores",
      programasyofertas: "/programas-y-ofertas",
      faqs: "/faqs",
      cookies: "/politica-de-cookies",
    },
    portalalumno: "https://portal-demoempleo.dotia.online/login/",
    portalalumnoregistro:
      "https://portal-demoempleo.dotia.online/registro",
    portalempresas: "https://portal-demoempleo.dotia.online/empresas",
    portalempresasregistro:
      "https://portal-demoempleo.dotia.online/solicitar-cuenta/",
    portaltutores: "https://tutores-demoempleo.dev.doubledot.es/login/",
  },
  en: {},
};



// WEBPACK FOOTER //
// ./src/translations/index.js